import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// Guest pages (login, register, etc.)
const Login = lazy(() => import('../pages/auth/Login'));
const Register = lazy(() => import('../pages/auth/Register'));
const ResetPassword = lazy(() => import('../pages/auth/ResetPassword'));
const OtpVerification = lazy(() => import('../pages/auth/OtpVerification'));
const NewPassword = lazy(() => import('../pages/auth/NewPassword'));
const guestRoutes = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/forgot-password',
    element: <ResetPassword />,
  },
  {
    path: '/reset-password',
    element: <NewPassword />,
  },
];

export default guestRoutes;

